// Description: Page that allow the user to create a template message with the WhatsApp API Channel
// Updated: 22/08/2025
// Author: Simon Franklin

// React
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

// Material UI Components
import { Box, Grid, TextField, FormControl, useMediaQuery, FormControlLabel, Radio, RadioGroup, FormLabel, Typography } from '@mui/material';

// Components and Functions for the project
import use123zapStore from '../../context/123zapStore';
import CampaignModal from '../../components/Modals/CampaignModal';
import HeaderPage from '../../components/HeaderPage/HeaderPage';
import { isAuthenticated } from '../../authMiddleware';
import { CreateTemplate } from '../../api/aws/Templates/CreateTemplate';
import { notify } from '../../utils/utils';
import ViewWhatsAppScreen from '../../components/WhatsAppScreen/ViewWhatsAppScreen';
import Footer from '../../components/Footer/Footer';
import Loading from '../../components/Loading/Loading';
import themeColors from '../../components/ThemeColors/ThemeColors';
import { GetVariables } from '../../api/aws/Listagens/GetVariables';
import TemplateInput from '../../components/Input/TemplateInput';
import DynamicButton from '../../components/DynamicButton/DynamicButton';
import StatusIcon from '../../components/StatusLabel/StatusIcon';
import { useDropzone } from 'react-dropzone';

// Render The Component
const TemplatePageAddWhatsAppAPI = () => {

    const userAuthenticated = use123zapStore((state) => state.userAuthenticated);
    const planoAtual = use123zapStore((state) => state.planoAtual);
    const userInfo = use123zapStore((state) => state.userInfo);
    const setUserInfo = use123zapStore((state) => state.setUserInfo);
    const setAlreadyFetchTemplates = use123zapStore((state) => state.setAlreadyFetchTemplates);
    const Navigate = useNavigate();

    const creatingCampaignWithHelpMode = JSON.parse(sessionStorage.getItem("creating_campaign")) || null;
    const [title, setTitle] = useState('');
    const isSmallScreen = useMediaQuery('(max-width:1200px)');
    const [showPreview, setShowPreview] = useState(false);
    const [openModalCampaign, setOpenModalCampaign] = useState(false);
    const [variablesOfTemplate, setVariablesOfTemplate] = useState({});
    const [messageTemporary, setMessageTemporary] = useState('');
    const [headerType, setHeaderType] = useState('none');
    const [header, setHeader] = useState('');
    const typeChannel = "WhatsApp";
    const [showLoading, setShowLoading] = useState(true)
    const [viewWhatsAppScreenProps, setViewWhatsAppScreenProps] = useState({
        type: 'whatsapp',
        messages: {
            messages: []
        }
    });

    const handleChange = (event) => {
        setHeaderType(event.target.value);
        setHeader("");
    };

    useEffect(() => {
        if (userAuthenticated && Object.keys(userInfo).length === 0) {
            const { decryptedData } = isAuthenticated();
            setUserInfo(decryptedData);
        }
    }, [userAuthenticated, userInfo]);

    useEffect(() => {
        if (userInfo['UUID']) {
            fetchData();
        }
    }, [userInfo])

    useEffect(() => {
        if (planoAtual !== 'UltraZap' && planoAtual !== 'ProZap') {
            Navigate('/acesso-restrito');
        }
    }, [planoAtual]);

    useEffect(() => {
        setViewWhatsAppScreenProps((prevProps) => ({
            ...prevProps,
            messages: {
                messages: [{ id: prevProps.messages.messages.length + 1, type: 'whatsapp', message: messageTemporary, fromMe: true, disabledRemove: true }],
            },
        }));

    }, [messageTemporary]);

    const fetchData = async () => {
        try {
            const translations = {
                "Personal_information": "Informações Pessoais",
                "Contact": "Contato",
                "Address": "Endereço",
                "Financial_References": "Referências Financeiras"
            };

            const resultJson = await GetVariables();

            const result = resultJson.data.reduce((acc, item) => {
                const category = translations[item.category] || item.category;
                if (!acc[category]) {
                    acc[category] = [];
                }

                acc[category].push(item.variableName);

                return acc;
            }, {});

            setVariablesOfTemplate(result);

        } catch (error) {
            console.error('Error fetching data from API:', error);
        } finally {
            setShowLoading(false);
        }
    };

    const saveTemplate = async () => {

        let get_messages = viewWhatsAppScreenProps.messages.messages.map((message) => {
            return {
                type: (message.type === "whatsapp" || message.type === "sms") ? "text" : message.type === "img" ? "img" : message.type,
                content: message.message
            };
        });

        if (headerType === "text" || headerType === "image" && header !== "") {
            let headerObject = { type: headerType === "image" ? "header-img" : "header-txt", content: header }

            get_messages = [
                ...get_messages,
                headerObject
            ];
        }

        let info = {};

        info = {
            'title': title,
            'messages': get_messages,
            'msg_type': 'Em análise',
            'channel_type': 'WhatsAppAPI'
        };

        info = JSON.stringify(info);

        const resultJson = await CreateTemplate(info);

        if (resultJson['status'] === 'success') {
            notify("Success", "Modelo criado com sucesso!", true);
            setAlreadyFetchTemplates(false);
            creatingCampaignWithHelpMode === true ? setOpenModalCampaign(true) : Navigate("/modelos");
        }
    }

    const verifyFieldsBeforeSave = async () => {
        if (title === "") {
            notify("Error", "Preencha o título do modelo", true);
        } else if ((String(typeChannel).includes("WhatsApp") && String(messageTemporary).length === 0)) {
            notify("Error", "Escreva uma mensagem antes de salvar o modelo", true);
        } else {
            await saveTemplate();
        }
    }

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        const reader = new FileReader();
        reader.onload = () => {
            setHeader(reader.result);
        };
        reader.readAsDataURL(file);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { 'image/*': [] },
        multiple: false,
    });

    if (showLoading) {
        return <Loading open={true} />;
    }

    return (
        <>
            <HeaderPage />
            <Box sx={{  background: "#F7F7FC" }}>
                <Grid container spacing={2} style={{ paddingTop: '20px' }}>
                    <Grid item xs={12} lg={6} xl={6} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Box sx={{ flexGrow: 1, justifyContent: 'center', backgroundColor: '#F7F7FC', width: { xs: 'calc(100% - 20px)', sm: "561.200px", lg: "90%" }, margin: { xs: '0 auto 20px', lg: '0 auto' }, padding: { xs: 0, lg: "20px 0px 20px 30px", xl: "20px" } }}>
                            <FormControl fullWidth>
                                <TextField
                                    id="outlined-basic"
                                    label="Nome do seu Modelo"
                                    variant="standard"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    InputLabelProps={{
                                        style: { fontSize: '20px' }
                                    }}

                                />
                            </FormControl>

                            <Box item xs={12} sx={{
                                background: themeColors.yellow01,
                                color: themeColors.yellow03,
                                fontSize: '14px',
                                padding: '13px',
                                borderRadius: '4px',
                                textTransform: "none",
                                width: "100%",
                                display: "flex",
                                gap: "10px",
                                marginTop: "20px",
                                alignItems: "center"
                            }}>
                                <StatusIcon status={"Alert"} color={themeColors.yellow03} />
                                A categoria desse tipo de modelo será definida pela Meta.
                            </Box>

                            <Box sx={{ paddingTop: { xs: '20px', sm: '0px' }, marginBottom: (isSmallScreen && showPreview) ? '20px' : 'none', position: 'relative' }}>
                                <Box sx={{
                                    color: 'rgb(129, 66, 252)',
                                    fontSize: '18px',
                                    position: 'absolute',
                                    top: { xs: (typeChannel === 'WhatsApp' || typeChannel === 'SMS') ? '16px' : (typeChannel === 'E-mail' && showPreview) ? '16px' : '0px', sm: (typeChannel === 'WhatsApp' || typeChannel === 'SMS') ? '16px' : (typeChannel === 'E-mail' && showPreview) ? '16px' : '0px' },
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    display: isSmallScreen ? 'block' : 'none',
                                    fontFamily: 'Satoshi',
                                    cursor: 'pointer',
                                    zIndex: '10'
                                }} onClick={() => setShowPreview(prev => !prev)}>
                                    {
                                        !showPreview ? "Exibir Prévia" : "Esconder Prévia"
                                    }
                                </Box>

                                <Box sx={{
                                    display: (isSmallScreen && showPreview) ? 'none' : 'block'
                                }}>
                                    <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                        <FormControl component="fieldset" fullWidth sx={{ paddingLeft: "16px" }}>
                                            <FormLabel component="legend" sx={{
                                                color: '#000',
                                                '&.MuiFormLabel-root.Mui-focused': {
                                                    color: '#000',
                                                },
                                                paddingBottom: "16px"
                                            }}>Cabeçalho</FormLabel>
                                            <RadioGroup row value={headerType} onChange={handleChange}>
                                                <FormControlLabel value="none" control={<Radio />} label="Nenhum" />
                                                <FormControlLabel value="text" control={<Radio />} label="Texto" />
                                                <FormControlLabel value="image" control={<Radio />} label="Imagem" />
                                            </RadioGroup>
                                        </FormControl>

                                        {
                                            headerType === "text" ? (
                                                <TemplateInput type={'whatsappapi'} value={header} handleChange={setHeader} variablesOfTemplate={variablesOfTemplate} multiline={false} header={true} />
                                            ) : headerType === "image" ? (
                                                <Box sx={{ position: 'relative', width: '100%' }}>
                                                    <Box
                                                        {...getRootProps()}
                                                        sx={{
                                                            width: 'calc(100% - 16px)',
                                                            height: 56,
                                                            border: '2px dashed #ccc',
                                                            borderRadius: 1,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            backgroundColor: isDragActive ? '#f0f0f0' : 'transparent',
                                                            marginTop: '16px',
                                                            marginLeft: '16px',
                                                        }}
                                                    >
                                                        <input {...getInputProps()} />
                                                        <Typography variant="body1" color="textSecondary">
                                                            Clique ou arraste sua foto aqui
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            ) : null
                                        }

                                        <TemplateInput type={'whatsappapi'} value={messageTemporary} handleChange={setMessageTemporary} variablesOfTemplate={variablesOfTemplate} />

                                        <Grid item xs={6}>
                                            <FormControl fullWidth sx={{ justifyContent: 'flex-end' }}>
                                                <DynamicButton handleFunction={verifyFieldsBeforeSave} style={{ width: '100%', padding: '13px' }} variant={"contained"} text={"Salvar Modelo"} />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>

                            <Box sx={{ display: { xs: 'none', lg: 'flex' }, justifyContent: 'start', alignItems: 'end', minHeight: '80px' }}>
                                <Footer />
                            </Box>
                        </Box>
                    </Grid>
                    {
                        (isSmallScreen && showPreview === true) ? (
                            <Grid item xs={12} lg={6} xl={6} padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}>
                                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFFF', padding: '20px', borderRadius: '15px', minHeight: { xs: "696px", lg: "100%", xl: "100%" }, width: { xs: "100%", sm: "561.200px", lg: "100%", xl: "100%" }, margin: { xs: "0 auto", lg: "0", xl: "0" }, borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' }}>
                                    <ViewWhatsAppScreen {...viewWhatsAppScreenProps} header={{ type: headerType, content: header }} />
                                </Box>
                            </Grid>
                        ) : (!isSmallScreen) ? (
                            <Grid item xs={12} lg={6} xl={6} padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}>
                                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFFF', padding: '20px', borderRadius: '15px', minHeight: { xs: "696px", lg: "100%", xl: "100%" }, width: { xs: "561.200px", lg: "100%", xl: "100%" }, margin: { xs: "0 auto", lg: "0", xl: "0" }, borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' }}>
                                    <ViewWhatsAppScreen {...viewWhatsAppScreenProps} header={{ type: headerType, content: header }} />
                                </Box>
                            </Grid>
                        ) : null
                    }
                    <Box sx={{ padding: { xs: "20px 0 0 25px", sm: "20px 0 0 0" }, display: { xs: "block", lg: "none" }, width: { xs: "100%", sm: "561.200px", lg: "100%", xl: "100%" }, margin: { sm: "0 auto", lg: "0", xl: "0" } }}>
                        <Footer />
                    </Box>
                </Grid>

            </Box >
            <CampaignModal
                cancelText="Criar mais um modelo"
                confirmText="Retornar ao formulário"
                subTitle={"Percebemos que você está configurando uma campanha. Gostaria de retornar ao formulário?"}
                isOpen={openModalCampaign}
                onClose={() => setOpenModalCampaign(false)}
                onCancel={() => Navigate("/modelos/canal")}
                onConfirm={() => (Navigate("/campanhas/adicionar"), sessionStorage.setItem("ReturToCampaign", true))}
                title={"Modelo criado com sucesso"}
                iconColor={themeColors.purple400}
            />
        </>
    )
}

export default TemplatePageAddWhatsAppAPI